import logo from './logo.svg';
import './App.css';
import MidiUpload from './MidiUpload.js';
import Typography from '@mui/material/Typography';

function App() {
  return (<>
    <MidiUpload />
    <Typography><a href="https://github.com/kosuke14/midishare">GitHub</a></Typography>
  </>);
}

export default App;
